import { defineAction, object } from '~/prix'
import neighborhoodSmartMappingAction from './geoNeighborhoodSmartMapping.action.json' assert { type: 'json' }
// import { multiPolygon } from '~/prix/types/presets/geo'
import { SmartMappingOptions } from '~/packages/geo/applySmartMapping/smartMapping.typing'
// import { z } from 'zod'

export const recommendedSmartMappingOptions: SmartMappingOptions = {
  useCustomDelimitationPolygon: false,
  preserveClassificationsQuantile: 0,
  maxGdfClassifications: 800,
  minOccurrencesPerClassification: 'auto',
  generalOutliersQuantile: 0.02,
  classificationOutliersQuantile: 0.02,
  minAreaKm2: 0.05,
  simplifyEpsilon: 0.0004,
  withTopology: true,
  predefinedClassifications: undefined,
  restrictToPredefinedOnly: undefined,
}

const neighborhoodSmartMappingDefinition = defineAction({
  ...neighborhoodSmartMappingAction,

  // input: z.object({
  //   delimitationPolygon: multiPolygon(),
  //   delimitationId: z.number(),
  //   delimitationType: z.enum(['municipality']),
  //   useCustomDelimitationPolygon: z.boolean().default(false),
  //   preserveClassificationsQuantile: z.number().min(0).nullish(),
  //   maxGdfClassifications: z.number().nullish(),
  //   minOccurrencesPerClassification: z.string().nullish(),
  //   generalOutliersQuantile: z.number().nullish(),
  //   classificationOutliersQuantile: z.number().nullish(),
  //   minAreaKm2: z.number().nullish(),
  //   simplifyEpsilon: z.number().nullish(),
  //   withTopology: z.boolean().nullish(),
  // }),
  // output: z.object({
  //   featureCollection: z.any(),
  // }),

  input: object<any>({}),
  output: object<any>({}),
})

export default neighborhoodSmartMappingDefinition
